<template>
    <div>
        <div class="dropdown__header dropdown__header--dark dropdown__header--big">
            <div class="dropdown__header-text dropdown__header-text--big dropdown__header-text--light">
                Zabudnuté heslo
            </div>
            <button v-if="showCloseIcon" class="dropdown__header-btn dropdown__header-btn--light"
                @click="onCloseclick">
                <span class="icon icon-close"></span>
            </button>
        </div>
        <div class="dropdown__body">
            <div class="text--white">
                <p>
                    Zadajte Vášu e-mailovú adresu a pošleme Vám nové heslo.
                </p>

                <form @submit.prevent="onSubmit">
                    <Field
                        :trimModel="true"
                        :fieldModel="$v.user.email"
                        :className="'input-field--dark'"
                        :field="usernameField">
                    </Field>

                    <div
                        class="dropdown__item--btn dropdown__item--btn-no-side-padding">
                        <button type="submit"
                            :disabled="authRequestState === 'running'"
                            class="button normal--button button--l button--full-width button--uppercase button--small-text">
                            <span v-if="authRequestState !== 'running'">
                                odoslať požiadavku
                            </span>
                            <span v-if="authRequestState === 'running'">
                                odesilani
                            </span>
                        </button>
                    </div>

                </form>

                <div v-if="openLogin"
                    class="dropdown__link text-link text-link--light"
                    @click.prevent.stop="openLogin">
                    Back to login
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import Field from '../ui/Field';
import {
    recoverPassword
} from '../../services/MapsfyApi';

export default {
    components: {
        Field
    },
    props: {
        openLogin: {
            type: Function
        },
        formId: {
            type: String,
            default: "login-form"
        },
        onCloseclick: {
            type: Function,
            required: false
        },
        showCloseIcon: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            authRequestState: null,
            submitStatus: null,
            user: {
                email: "",
            },
            emailId: this.formId + '-inputEmail',
            passwordId: this.formId + '-inputPassword',
            usernameField: {
                atrName: "username",
                dataType: "text",
                descr: this.$t('components.auth.login.email_field_desc'),
                isMandatory: true,
                maxValue: "85",
                minValue: "5",
                title: this.$t('components.auth.login.email_field_title')

            }
        };
    },
    validations: {
        user: {
            email: {
                required
            }
        }
    },
    methods: {
        onSubmit() {
            this.$v.$touch();

            this.submitStatus = null;
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            }

            if (!this.$v.$invalid) {
                this.authRequestState = 'running';
                recoverPassword(this.user.email);
            }

        }
    }
};
</script>

<style scoped>
</style>

